import api from '@/api';

const state = {
  opportunities: [],
  opportunityStatuses: [],
};

const getters = {
  getOpportunityNameById: state => (id) => {
    const opportunityStatus = state.opportunityStatuses.find(o => o.id === parseInt(id, 10));
    return opportunityStatus ? opportunityStatus.name : '';
  },
};

const actions = {
  async getOpportunities({ commit }, payload) {
    const response = await api.post('Opportunity/Opportunities', {
      OpportunityStatusId: payload.opportunityStatus,
      StartDate: payload.startDate,
      EndDate: payload.endDate,
    });
    commit('opportunities', response.data.opportunities);
  },
  async getOpportunityStatuses({ commit }) {
    const response = await api.get('Opportunity/OpportunityStatuses');
    commit('opportunityStatuses', response.data.opportunityStatuses);
  },
};

const mutations = {
  opportunities(state, payload) {
    state.opportunities = payload;
  },
  opportunityStatuses(state, payload) {
    state.opportunityStatuses = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
